'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
var $ = require("jquery");
var Init = /** @class */ (function () {
    function Init() {
        var _this = this;
        this.setHeight();
        this.viewTest();
        var os = this.getDevice();
        if (os === 'other') {
            $(window).on('resize', function () {
                _this.setHeight();
            });
        }
    }
    // iPhoneのビューポートに対応する
    Init.prototype.setHeight = function () {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    };
    Init.prototype.viewTest = function () {
        console.log('テスト');
    };
    Init.prototype.getDevice = function () {
        var ua = navigator.userAgent;
        if (/android/i.test(ua)) {
            return "android";
        }
        else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            return "ios";
        }
        return "other";
    };
    return Init;
}());
exports.Init = Init;
exports.default = Init;
